import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home'
import index from '@/pages/index'

import aboutsUs from '@/pages/aboutsUs/aboutsUs'
import aboutsUsRy from '@/pages/aboutsUs/aboutsUsRy'
import news from '@/pages/news/news'
import productAndService from '@/pages/productAndService/productAndService'
import callMe from '@/pages/callMe/callMe'

/**
 * /服务详情
 */

import intellectualProperty from '@/pages/service/intellectualProperty/intellectualProperty'// 知识产权
import qualifications from '@/pages/service/qualifications/qualifications'//资质认定
import projectApplication from '@/pages/service/projectApplication/projectApplication'//项目申报
import financialAudit from '@/pages/service/financialAudit/financialAudit'//财税审计
import parkServices from '@/pages/service/parkServices/parkServices'//园区服务
import digitalsoftware from '@/pages/service/digitalsoftware/digitalsoftware'//园区服务

Vue.use(Router)

export default new Router({

  routes: [
    {
      path: '/',
      component: Home,
      children: [
        {
          path: '/',
          name: 'index',
          component: index,
          meta: {
            active: 'index'
          },
        },
        {
          path: '/aboutsUs',
          name: 'aboutsUs',
          component: aboutsUs,
          meta: {
            active: 'aboutsUs'
          }
        },
        {
          path: '/news',
          name: 'news',
          component: news,
          meta: {
            active: 'news'
          }
        },
        {
          path: '/productAndService',
          name: 'productAndService',
          component: productAndService,
          meta: {
            active: 'productAndService'
          }
        },
        {
          path: '/callMe',
          name: 'callMe',
          component: callMe,
          meta: {
            active: 'callMe'
          }
        },
        {
          path: '/intellectualProperty',
          name: 'intellectualProperty',
          component: intellectualProperty,
          meta: {
            active: 'intellectualProperty'
          }
        },
        {
          path: '/qualifications',
          name: 'qualifications',
          component: qualifications,
          meta: {
            active: 'qualifications'
          }
        },
        {
          path: '/projectApplication',
          name: 'projectApplication',
          component: projectApplication,
          meta: {
            active: 'projectApplication'
          }
        },
        {
          path: '/financialAudit',
          name: 'financialAudit',
          component: financialAudit,
          meta: {
            active: 'financialAudit'
          }
        },
        {
          path: '/parkServices',
          name: 'parkServices',
          component: parkServices,
          meta: {
            active: 'parkServices'
          }
        },
        {
          path: '/digitalsoftware',
          name: 'digitalsoftware',
          component: digitalsoftware,
          meta: {
            active: 'digitalsoftware'
          }
        },
        {
          path: '/aboutsUsRy',
          name: 'aboutsUsRy',
          component: aboutsUsRy,
          meta: {
            active: 'aboutsUsRy'
          }
        },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/router.js